export default __webpack_public_path__ + "static/media/GRISI.436c5afb.png";